import { baccarat } from './baccarat';
import { bigSix } from './bigSix';
import { blackjack } from './blackjack';
import { casinoWar } from './casinoWar';
import { crash } from './crash';
import { craps } from './craps';
import { dice } from './dice';
import { highLow } from './highLow';
import { holdem } from './holdem';
import { horseRacing } from './horseRacing';
import { liarsDice } from './liarsDice';
import { mahjong } from './mahjong';
import { mines } from './mines';
import { plinko } from './plinko';
import { roulette } from './roulette';
import { scratchers } from './scratchers';
import { slots } from './slots';
import { threeCardPoker } from './threeCardPoker';
import { tower } from './tower';
import { videoPoker } from './videoPoker';
import type { CasinoGame, GameId } from './types';

// Each game's own state type is erased here; the casino layer only passes a
// game's state back into the same game's functions, never across games.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GAMES: Record<GameId, CasinoGame<any>> = {
  slots,
  blackjack,
  scratchers,
  crash,
  videopoker: videoPoker,
  baccarat,
  highlow: highLow,
  mines,
  roulette,
  craps,
  threecard: threeCardPoker,
  bigsix: bigSix,
  tower,
  plinko,
  dice,
  war: casinoWar,
  horses: horseRacing,
  liarsdice: liarsDice,
  holdem,
  mahjong,
};
